import { StaticLayout } from './static-layout'

export function AboutPage() {
  return (
    <StaticLayout title="About mkdn.app" description="A free, collaborative markdown editor.">
      <h2>Our story</h2>
      <p>
        mkdn.app was born from a desire to have a simple, distraction-free markdown editor that
        could be shared in real-time without forcing collaborators to sign up. We built it for
        ourselves and decided to keep it free for everyone.
      </p>
      <h2>What we believe</h2>
      <ul>
        <li>
          <strong>Simplicity.</strong> Tools should get out of the way and let you focus on the
          content.
        </li>
        <li>
          <strong>Collaboration without friction.</strong> Sharing a document should be one click,
          and viewing it should not require an account.
        </li>
        <li>
          <strong>Privacy by default.</strong> Documents are private unless you choose to share
          them. We do not sell data, and we do not run third-party trackers in the editor.
        </li>
        <li>
          <strong>Free forever.</strong> The product is free. No paywalls, no premium tier.
        </li>
      </ul>
      <h2>Open contributions</h2>
      <p>
        Have feedback, found a bug, or want to suggest a feature? Reach out via the{' '}
        <a href="/contact">contact page</a>.
      </p>
    </StaticLayout>
  )
}
